import { useRef } from 'react';

let nextId = 1;

export function useInstanceId(prefix = 'cmp') {
  const idRef = useRef<number>(null!);
  if (idRef.current == null) {
    idRef.current = nextId++;
  }
  return `${prefix}-${idRef.current}`;
}
